module.exports = __webpack_public_path__ + "img/planner-1.fe32a69c.png";